import Schedule from "../../components/Schedule.jsx";


const EventDetails = () => {
    return (
        <div className="schedule m-5 text-2xl">
        <Schedule />
        

        </div>
    );
}
export default EventDetails;